import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface commonType {
  // loading: boolean;
  chainModal: {
    type: "website" | "page" | "",
    visible: boolean;
    chainIds?: number[];
  };
  
  routeParams: {
    lang?: string;
    chain?: string;
  };
  
}


const initialState: commonType = {
  // loading: false,
  chainModal: {type: "", visible: false},
  routeParams: {
    lang: undefined,
    chain: undefined,
  },
};

const commonControllSlice = createSlice({
  name: 'commonControll',
  initialState,
  reducers: {
    // setLoading: (state, action: PayloadAction<boolean>) => {
    //   state.loading = action.payload;
    // },
    setChainModalOpen: (state, action: PayloadAction<{type: "website" | "page" | "", visible: boolean}>) => {
      state.chainModal = action.payload;
    },
    setRouteParams: (state, action: PayloadAction<{ lang?: string; chain?: string }>) => {
      state.routeParams = action.payload;
    }
  },
});

export const { 
  // setLoading, 
  setChainModalOpen,
  setRouteParams,
 } = commonControllSlice.actions;

export default commonControllSlice;
